import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, { encodeValuesOnly: true });

// Get Measurement Detail List with Query (for remote ODataGrid)
export const getMeasurementDetailListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_MEASUREMENT_DETAILS}?${stringifyParams(params)}`
	);
};

// Get Single Measurement Detail
export const getMeasurementDetailApi = id => {
	return apiClient.get(`${WATER_RIGHTS_BASE}${url.GET_MEASUREMENT_DETAIL}${id}`);
};

// Add New Measurement Detail
export const addMeasurementDetailApi = data => {
	return apiClient.post(`${WATER_RIGHTS_BASE}${url.POST_MEASUREMENT_DETAIL}`, data);
};

// Update Measurement Detail
export const updateMeasurementDetailApi = (id, data) => {
	return apiClient.put(`${WATER_RIGHTS_BASE}${url.PUT_MEASUREMENT_DETAIL}${id}`, data);
};

// Delete Measurement Detail
export const deleteMeasurementDetailApi = id => {
	return apiClient.delete(`${WATER_RIGHTS_BASE}${url.DELETE_MEASUREMENT_DETAIL}${id}`);
};
